
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'
import lodash from 'lodash'

@Observer
@Component({
  name: 'HomeworkReport'
})
export default class HomeworkReport extends Vue {
  @Prop({ required: true }) visible: boolean
  @Prop({ required: true }) bizId: string | number
  @Prop({ required: true }) bizType: number

  get PageStore() {
    return this.$store.$audit
  }

  reason = [
    { label: '传播淫秽色情/低俗内容', value: '传播淫秽色情/低俗内容' },
    { label: '违规商业广告', value: '违规商业广告' },
    { label: '封建迷信/违法信息', value: '封建迷信/违法信息' },
    { label: '盗用/篡改他人作品', value: '盗用/篡改他人作品' },
    { label: '诋毁他人作品', value: '诋毁他人作品' },
    { label: '人身攻击/引战言论', value: '人身攻击/引战言论' },
    { label: '人虚假学习成就', value: '人虚假学习成就' },
    { label: '泄漏隐私信息', value: '泄漏隐私信息' },
    { label: '涉政敏感内容', value: '涉政敏感内容' },
    { label: '其他', value: '其他' }
  ]

  model = {
    label: '',
    remark: ''
  }

  onReset() {
    this.model = {
      label: '',
      remark: ''
    }
  }

  async handleConfirm() {
    if (this.model.label === '') {
      this.$msg('请选择举报理由')
      return
    }
    const data = lodash.assign({ bizId: this.bizId, bizType: this.bizType }, this.model)
    const res = await this.PageStore.onReportViolation(data)
    if (res === true) {
      this.$msg('举报成功', 'success')
      this.$emit('cancel')
    }
  }

  @Watch('visible')
  changeVisible(val: boolean) {
    if (!val) {
      this.onReset()
      return
    }
  }

  created() {}

  mounted() {}

  destroyed() {}
}
